import styled from "styled-components";
import { FaTwitter } from "react-icons/fa";

const Wrapper = styled.div`
  margin-top:30px;
`;

const TwitterButton = styled.a`
  text-decoration:none;
  border: 0;
  border-radius: 3px;
  padding: 10px 18px;
  background: ${props => props.theme.color};
  color: ${props => props.theme.textcolor};
  font-family: Nunito;
  cursor: pointer;
  float:left;
  display:flex;
  justify-content:center;
  align-items:center;
  transition: all 0.75s ease-out;
  &:hover {
    opacity:0.85;
  }
`;

const NewQuote = styled(TwitterButton)`
  float:right;
`;

const ButtonBox = ({ currentQuote, getNewQuote }) => {
  const href = { href: `https://twitter.com/intent/tweet?text="${currentQuote.quote}" ${currentQuote.author}` };

  return (
    <Wrapper>
      <TwitterButton {...href} target="_blank" rel="noopener noreferrer"><FaTwitter /></TwitterButton>
      <NewQuote onClick={() => getNewQuote()}>New Quote</NewQuote>
    </Wrapper>
  );
};

export default ButtonBox;